<template>
  <Layout>
    <ModalCancelPurchase />
    <Title
      title="Compras"
      v-if="titleIsLoaded"
      :hasPrint="true"
      :hasNewRegister="true"
      :routeNewRegister="handleNavigationRegister"
      :newRegisterButtonName="'Nova Compra'"
      :disableNewButton="issuerBasicData.isEmpty"
      :reasonsToDisableNewButton="issuerBasicData.requiredData"
    />
    <div class="pending-documents mb-3" v-if="nfePending.length">
      <div
        class="pending-documents-header"
        @click="nfePendingOpen = !nfePendingOpen"
      >
        <span class="pending-documents-title" :class="{ 'text-primary': nfePendingOpen }"
          >Documentos pendentes</span
        >
        <div class="d-flex align-items-center">
          <span class="pending-documents-badge me-2">!</span>
          <ChevronUp v-if="nfePendingOpen" :size="20" fillColor="#6c757d" />
          <ChevronDown v-else :size="20" fillColor="#6c757d" />
        </div>
      </div>
      <b-collapse v-model="nfePendingOpen">
        <div class="pending-documents-body">
          <div class="alert alert-info mb-0 position-relative">
            <span class="me-3 ms-3"
              >As notas abaixo apresentam inconsistências. Para corrigir,
              <b>reabra e verifique os dados fiscais dos produtos</b>:</span
            >
            <ul style="margin-bottom: 0!important;">
              <li v-for="(nfe, key) in nfePending" :key="key">Número: {{ nfe.nfeNumber }}</li>
            </ul>
          </div>
        </div>
      </b-collapse>
    </div>
    <Table
      class="table-hover"
      :key="tableKey"
      :tableData="tableData"
      :items="summaryPurchases"
      :pagination="true"
      :perPage="paginationPurchase.perPage"
      :startItem="paginationPurchase.startItem"
      :endItem="paginationPurchase.endItem"
      :totalItems="paginationPurchase.totalItems"
      :page="paginationPurchase.currentPage"
      :onClickRow="handleNavigationEdit"
      :onSearch="search"
      @changeItemsPerPage="handleChangeItemsPerPage"
      @changePage="handleChangePage"
    >
    </Table>
  </Layout>
</template>

<script>
import { Layout, Title, Table, TableData, Actions } from '@/components';
import { mapState, mapActions } from 'vuex';
import ChevronUp from 'vue-material-design-icons/ChevronUp.vue';
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue';
import ModalCancelPurchase from '../components/Modals/ModalCancelPurchase/ModalCancelPurchase.vue';

export default {
  name: 'purchase',
  components: {
    Layout,
    Title,
    Table,
    ModalCancelPurchase,
    ChevronUp,
    ChevronDown,
  },
  async mounted() {
    await Promise.all([this.emptyIssuerBasicData(), this.resetPurchase(), this.setPurchase()]);

    try {
      await this.setLoading(true);
      await this.setSummaryPurchases({
        search: null,
        pagination: this.paginationPurchase,
      });
      this.nfePending = await this.findPendingPurchases();
      await this.setLoading(false);
    } catch {
      this.setLoading(false);
    }

    this.titleIsLoaded = true;
  },
  computed: {
    ...mapState('purchase', ['summaryPurchases', 'paginationPurchase']),
    ...mapState('componentsPurchase', ['modalCancelPurchaseIsOpen']),
    ...mapState('client', ['client']),
    optionsStatus() {
      return [{ value: 'todos', text: 'Todos' }];
    },
    tableData() {
      const { Data, TABLE_CELL_ALIGN } = TableData;

      const DataTable = new Data({
        select: true,
        panelActions: true,
        advancedFilters: true,
        onSearch: this.search,
        titleMobile: (item) => item.description,
      });

      DataTable.addField({
        key: 'entryDate',
        label: 'Data',
        sortable: true,
        align: TABLE_CELL_ALIGN.center,
        formatter: (value) => this.$moment(value).format('DD/MM/YYYY'),
        width: 100,
      })
        .addField({
          key: 'nfeNumber',
          label: 'Número',
          sortable: true,
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'supplier',
          label: 'Fornecedor',
          sortable: true,
          width: 600,
          align: TABLE_CELL_ALIGN.left,
        })
        .addField({
          key: 'vNF',
          label: 'Total R$',
          sortable: true,
          width: 150,
          formatter: (value) =>
            new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(value),
          align: TABLE_CELL_ALIGN.right,
        })
        .addActions(Actions('cancel', (selected) => this.cancel(selected)));
      return DataTable;
    },
  },
  data() {
    return {
      nfePending: [],
      nfePendingOpen: false,
      titleIsLoaded: false,
      issuerBasicData: {
        isEmpty: false,
        requiredData: ['Endereço', 'CPF/CNPJ'],
      },
      tableKey: 0,
      form: {
        date: this.$moment(this.$moment().format('YYYY-MM-01')).toDate(),
        search: '',
        status: 'todos',
      },
    };
  },
  methods: {
    ...mapActions('purchase', [
      'resetPurchase',
      'searchPurchases',
      'setPurchase',
      'setSummaryPurchases',
      'setDetailedPurchase',
      'findPendingPurchases',
    ]),
    ...mapActions('application', ['setLoading']),
    ...mapActions('client', ['setClient']),
    ...mapActions('componentsPurchase', ['toggleModalCancelPurchase', 'setModalCancelPurchaseIds']),
    emptyIssuerBasicData() {
      if (!this.client.addressCollection.length || !this.client.identification) {
        this.issuerBasicData.isEmpty = true;
      }
    },
    async search(value) {
      await this.setLoading(true);
      await this.setSummaryPurchases({
        search: value,
        pagination: { ...this.paginationPurchase, currentPage: 1 },
      });
      await this.setLoading(false);
    },
    async handleChangeItemsPerPage(items) {
      const pagination = {
        ...this.paginationPurchase,
        perPage: items,
        currentPage: 1,
      };
      await this.setLoading(true);
      await this.setSummaryPurchases({ search: null, pagination });
      await this.setLoading(false);
    },
    async handleChangePage(page) {
      const pagination = { ...this.paginationPurchase, currentPage: page };
      await this.setLoading(true);
      await this.setSummaryPurchases({
        search: null,
        pagination,
      });
      await this.setLoading(false);
    },
    async handleNavigationEdit(item) {
      if (!item.id) return null;

      return this.$router.push({
        name: 'PurchaseEdit',
        params: { id: item.id },
      });
    },
    async handleNavigationRegister() {
      return this.$router.push({ name: 'PurchaseRegister' });
    },
    cancel(selected) {
      this.setModalCancelPurchaseIds(selected);
      this.toggleModalCancelPurchase();
    },
  },
  watch: {
    modalCancelPurchaseIsOpen() {
      if (!this.modalCancelPurchaseIsOpen) {
        this.tableKey += 1;
      }
    },
  },
};
</script>

<style scoped>
.pending-documents {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background-color: #fff;
  overflow: hidden;
}

.pending-documents-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1.5rem;
  cursor: pointer;
  user-select: none;
}

.pending-documents-title {
  font-weight: 700;
  color: #212529;
}

.pending-documents-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: rgba(220, 53, 69, 0.15);
  color: #dc3545;
  font-weight: 700;
  font-size: 13px;
  line-height: 1;
}

.pending-documents-body {
  padding: 0 1.5rem 1.25rem;
}

.pending-documents-body .alert {
  border-radius: 6px;
  padding: 1rem 1.5rem;
}
</style>
